











import Vue from 'vue'
export default Vue.extend({
  name: 'IconDownload',
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
})
